import React from 'react';
import { Icon, IconNames } from 'components';
import { colors, sizes } from 'constants/styles';
import { ErrorIndicatorContainer } from './ApprovalLevelsMissingRequiredApprover.styles';
const ApprovalLevelsMissingRequiredApprover = ({ warning = false }) => (React.createElement(ErrorIndicatorContainer, null,
    React.createElement(Icon, { color: warning ? 'var(--color-gold40)' : colors.colorRedBoldHex, icon: warning ? IconNames.WARNING_SIGN : IconNames.ERROR, size: sizes.iconSizes.LARGE }),
    "A required approver is no longer active"));
export default ApprovalLevelsMissingRequiredApprover;
